<template>
  <RouterView #default="{ Component }">
    <Component :is="Component" />
  </RouterView>
</template>

<script setup lang="ts">
import type { ReportQuery } from "@/services/reports/reportQuery"

const globalQuery = ref<ReportQuery>({
  start: DateFns.format(new Date(), "yyyy-MM-dd"),
  end: DateFns.format(new Date(), "yyyy-MM-dd"),
})

provide(GLOBAL_QUERY_KEY, globalQuery)
</script>
